import React from 'react';
import { motion } from 'framer-motion';
export function PullQuote() {
  return <section className="px-4 md:px-8 py-24 md:py-32 bg-ink text-paper relative overflow-hidden" data-id="element-140">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-141">
        <div className="absolute top-10 right-10 font-serif text-[20rem] leading-none text-vermillion" data-id="element-142">
          ״
        </div>
      </div>

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-143">
        <motion.blockquote initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-20%'
      }} transition={{
        duration: 0.8
      }} className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-12" data-id="element-144">
          <span className="text-vermillion" data-id="element-145">״</span>
          האמנות הגדולה ביותר של זמננו היא היכולת להישאר ממוקדים בעולם שתוכנן
          להסיח את דעתנו.
          <span className="text-vermillion" data-id="element-146">״</span>
        </motion.blockquote>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="font-sans" data-id="element-147">
          <div className="text-xl font-bold text-paper mb-1" data-id="element-148">
            פרופ׳ עמוס שפירא
          </div>
          <div className="text-paper/60 text-sm tracking-wide" data-id="element-149">
            מתוך ״ארכיטקטורה של תודעה״, גיליון 03
          </div>
        </motion.div>
      </div>
    </section>;
}